const PUBLIC_EMAIL_DOMAINS = [
  'gmail.com',
  'googlemail.com',
  'hotmail.com',
  'hotmail.com.br',
  'outlook.com',
  'outlook.com.br',
  'yahoo.com',
  'yahoo.com.br',
  'icloud.com',
  'aol.com',
  'live.com',
  'msn.com',
  'protonmail.com',
  'yandex.com',
  'mail.com',
  'zoho.com',
  'uol.com.br',
  'bol.com.br',
  'terra.com.br',
  'ig.com.br',
  'globo.com',
  'r7.com',
]

export function isBusinessEmail(email) {
  if (!email || typeof email !== 'string') {
    return false
  }

  // Verifica se é um email válido
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!emailRegex.test(email)) {
    return false
  }

  // Extrai o domínio do email
  const domain = email.split('@')[1].toLowerCase()

  // Verifica se o domínio NÃO está na lista de domínios públicos
  return !PUBLIC_EMAIL_DOMAINS.includes(domain)
}
